<template>
  <div class="shenyunjie-chart-thermometer-e" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartThermometerE",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    pattern: {
      type: String,
      default: "temperature"
    },
    value: {
      type: Number,
      default: 0
    },
    changeColour: {
      type: Boolean,
      default: true
    },
    size: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        title: {
          textStyle: {
            color: "#5470C6",
            align: "center"
          },
          left: "center"
        },
        yAxis: [{
          show: false,
          data: [],
          min: 0,
          max: 180,
          axisLine: {
            show: false
          }
        }],
        xAxis: [{
          show: false,
          min: -10,
          max: 80,
          data: []
        }, {
          show: false,
          min: -10,
          max: 80,
          data: []
        }, {
          show: false,
          min: -10,
          max: 80,
          data: []
        }, {
          show: false,
          max: 80
        }],
        series: [{
          name: "条",
          type: "bar",
          xAxisIndex: 0,
          data: [{
            value: 50,
            label: {
              show: true,
              width: 20,
              height: 100,
              rich: {
                back: {
                  align: "center",
                  lineHeight: 50,
                  fontFamily: "digifacewide"
                },
                unit: {
                  fontFamily: "微软雅黑",
                  lineHeight: 50
                },
                downTxt: {
                  lineHeight: 50,
                  align: "center"
                }
              }
            },
          }],
          itemStyle: {},
          z: 2
        }, {
          name: "白框",
          type: "bar",
          xAxisIndex: 1,
          barGap: "-100%",
          data: [178],
          itemStyle: {
            color: "#0C2E6D",
            borderRadius: 50
          },
          z: 1
        }, {
          name: "外框",
          type: "bar",
          xAxisIndex: 2,
          barGap: "-100%",
          data: [180],
          itemStyle: {
            color: "#4577BA",
            borderRadius: 50
          },
          z: 0
        }, {
          name: "圆",
          type: "scatter",
          emphasis: {
            scale: false,
          },
          data: [0],
          xAxisIndex: 0,
          itemStyle: {
            color: "#93FE94",
            opacity: 1
          },
          z: 2
        }, {
          name: "白圆",
          type: "scatter",
          emphasis: {
            scale: false,
          },
          data: [0],
          xAxisIndex: 1,
          itemStyle: {
            color: "#0C2E6D",
            opacity: 1
          },
          z: 1
        }, {
          name: "外圆",
          type: "scatter",
          emphasis: {
            scale: false,
          },
          data: [0],
          xAxisIndex: 2,
          itemStyle: {
            color: "#4577BA",
            opacity: 1
          },
          z: 0
        }, {
          name: "刻度",
          type: "bar",
          yAxisIndex: 0,
          xAxisIndex: 3,
          label: {
            show: true,
            position: "left",
            distance: 15,
            fontSize: 14
          },
          barGap: "-100%",
          barWidth: 1,
          itemStyle: {
            color: "#000000",
            borderRadius: 120
          },
          z: 0
        }]
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeThermometerE);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeThermometerE() {
      let self = this;
      if (self.chart) {
        self.init();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        if (!self.chart) {
          let theme = self.theme || (this.$YunJie || {}).theme || "standard";
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark", { renderer: "canvas", useDirtyRect: false });
          } else {
            self.chart = echarts.init(document.getElementById(self.id), null, { renderer: "canvas", useDirtyRect: false });
          }
        }
        let width = document.getElementById(self.id).offsetWidth;
        // 配置汇总
        let parameter = {
          title: {
            text: self.size ? (self.pattern == "temperature" ? "温度" : "湿度") : null
          },
          grid: {
            top: self.size ? 32 : 4,
            bottom: self.size ? "14%" : 16,
            left: self.size ? ((width * 0.9 - 5) / 2) : 16,
            right: self.size ? "10%" : 0
          }
        };
        let opt = merge(self.defaultOption, parameter);
        // 刻度
        let graduation = [];
        let LabelFormatter = null;
        // 中间线的渐变色和文本内容
        let Gradient = [];
        if (self.pattern == "temperature") {
          for (let i = 0, len = 175; i <= len; i++) {
            if (i < 10 || i > 170) {
              graduation.push("");
            } else {
              if ((i - 10) % 20 === 0) {
                graduation.push("-3");
              } else if ((i - 10) % 4 === 0) {
                graduation.push("-1");
              } else {
                graduation.push("");
              }
            }
          }
          LabelFormatter = function (params) {
            if (params.dataIndex > 170 || params.dataIndex < 10) {
              return "";
            } else {
              if ((params.dataIndex - 10) % 20 === 0) {
                return params.dataIndex - 50;
              } else {
                return "";
              }
            }
          }
          if (self.value > 40) {
            Gradient = [
              { offset: 0, color: "#93FE94" },
              { offset: 0.5, color: "#E4D225" },
              { offset: 1, color: "#E01F28" }
            ];
          } else if (self.value >= 15) {
            Gradient = [
              { offset: 0, color: "#93FE94" },
              { offset: 1, color: "#E4D225" }
            ];
          } else {
            Gradient = [
              { offset: 1, color: "#93FE94" }
            ];
          }
        } else {
          for (let i = 0, len = 175; i <= len; i++) {
            if (i < 20 || i > 170) {
              graduation.push("");
            } else {
              if ((i - 20) % 30 === 0) {
                graduation.push("-3");
              } else if ((i - 20) % 6 === 0) {
                graduation.push("-1");
              } else {
                graduation.push("");
              }
            }
          }
          LabelFormatter = function (params) {
            if (params.dataIndex > 170 || params.dataIndex < 20) {
              return "";
            } else {
              if ((params.dataIndex - 20) % 30 === 0) {
                return (params.dataIndex - 20) / 1.5;
              } else {
                return "";
              }
            }
          }
          if (self.value > 80) {
            Gradient = [
              { offset: 0, color: "#93FE94" },
              { offset: 0.5, color: "#E4D225" },
              { offset: 1, color: "#E01F28" }
            ];
          } else if (self.value >= 40) {
            Gradient = [
              { offset: 0, color: "#93FE94" },
              { offset: 1, color: "#E4D225" }
            ];
          } else {
            Gradient = [
              { offset: 1, color: "#93FE94" }
            ];
          }
        }
        let leftColor = Gradient[Gradient.length - 1].color;
        opt.series[0].barWidth = self.size ? 18 : 6;
        opt.series[0].data[0].value = self.pattern == "temperature" ? Math.max(Math.min(self.value + 50, 170), 0) : Math.max(Math.min((self.value * 1.5 + 20), 170), 0);
        if (self.size) {
          opt.series[0].data[0].label.formatter = `{back| ${self.value} }{unit|${self.pattern == "temperature" ? "°C" : "%"}}`;
        } else {
          opt.series[0].data[0].label.formatter = `{back|${self.value}}`;
        }
        opt.series[0].data[0].label.rich.back.color = self.changeColour ? leftColor : null;
        opt.series[0].data[0].label.rich.back.fontSize = self.size ? 30 : 12;
        opt.series[0].data[0].label.rich.unit.color = self.changeColour ? leftColor : null;
        opt.series[0].data[0].label.rich.unit.fontSize = self.size ? 15 : 12;
        opt.series[0].data[0].label.rich.downTxt.color = self.changeColour ? leftColor : null;
        opt.series[0].data[0].label.rich.unit.fontSize = self.size ? 25 : 12;
        opt.series[0].data[0].label.position = self.size ? [60, 0] : [12, 0];
        opt.series[0].itemStyle.color = self.changeColour ? echarts.graphic.LinearGradient(0, 1, 0, 0, Gradient) : "#93FE94";
        opt.series[1].barWidth = self.size ? 18 : 6;
        opt.series[2].barWidth = self.size ? 28 : 14;
        opt.series[3].symbolSize = self.size ? 38 : 12;
        opt.series[4].symbolSize = self.size ? 50 : 20;
        opt.series[5].symbolSize = self.size ? 60 : 28;
        if (self.size) {
          opt.series[6].itemStyle.color = self.theme == "standard" ? "#000000" : "#CCCCCC";
          opt.series[6].data = graduation;
          opt.series[6].label.formatter = LabelFormatter;
          opt.xAxis[3].min = (280 / width - 1) * 10;
        } else {
          opt.series = opt.series.slice(0, -1);
          opt.xAxis = opt.xAxis.slice(0, -1);
        }
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeThermometerE);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    pattern() {
      this.init();
    },
    value() {
      this.init();
    },
    changeColour() {
      this.init();
    },
    size() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-thermometer-e {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/thermometerE.vue